var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wizard-step-jobmatch-location" }, [
    _c(
      "div",
      { staticClass: "location-wrapper bg-white mt-4 rounded border" },
      [
        _c("LocationComponentsContainer", {
          staticClass: "border-bottom",
          attrs: {
            windowWidth: _vm.windowWidth,
            userInfo: _vm.userInfo,
            useAllCountries: true,
            useIcon: true,
            locationToInit: _vm.locationToInit,
            countryToInit: _vm.countryToInit,
            canSearchFromMap: true,
            settings: _vm.settings,
          },
          on: {
            startSearch: function ($event) {
              return _vm.startSearch(true)
            },
            removeLocation: function ($event) {
              return _vm.resetProfileGeo()
            },
            countrySelected: function ($event) {
              return _vm.resetProfileGeo()
            },
            emitParams: function ($event) {
              return _vm.startSearch(true)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }